import React from "react";
import CommonSection from "../shared/CommonSection";
import Newsletter from "../shared/Newsletter";
import { Container, Row, Col } from "reactstrap";
import AchievementsSection from "../shared/AchievementsSection";

import "./../styles/privacy-policy.css";
import Subtitle from "../shared/Subtitle";

const PrivacyPolicy = () => {
  return (
    <>
      <CommonSection title={"Privacy Policy"} />
      <section>
        <Container>
          <Row>
            <Col lg="12">
              <div className="privacy__content">
                <h1 className="text-center text-4xl mb-4">
                  The Rustic Paths
                </h1>
                <div className="mb-4">
                  <h2 className="text-xl font-semibold">
                    What information do we collect?
                  </h2>
                  <ul className="list-disc list-inside ml-6">
                    <li>
                      Book a private driver service through our website or app
                    </li>
                    <li>Create an account on our website or app</li>
                    <li>Contact us for customer support</li>
                  </ul>
                  <p>
                    The personal information we collect may include your name,
                    email address, phone number, payment information, and travel
                    itinerary.
                  </p>
                </div>

                <div className="mb-4">
                  <h2 className="text-xl font-semibold">
                    How do we use your information?
                  </h2>
                  <ul className="list-disc list-inside ml-6">
                    <li>
                      To provide you with the private driver services you have
                      booked
                    </li>
                    <li>
                      To communicate with you about your booking and other
                      related matters
                    </li>
                    <li>To improve our services and website</li>
                    <li>
                      We will send you marketing and promotional materials if
                      you have opted in to receive them
                    </li>
                  </ul>
                </div>

                <div className="mb-4">
                  <h2 className="text-xl font-semibold">
                    How do we share your information?
                  </h2>
                  <ul className="list-disc list-inside ml-6">
                    <li>
                      Our partner private driver companies will provide you
                      with the services you have booked
                    </li>
                    <li>
                      Payment processors, in order to process your payments
                    </li>
                    <li>
                      Marketing and advertising partners will send you targeted
                      marketing and promotional materials if you have opted in
                      to receive them
                    </li>
                  </ul>
                  <p>
                    We will not sell or share your personal information with
                    any other third parties without your consent.
                  </p>
                </div>

                <div className="mb-4">
                  <h2 className="text-xl font-semibold">
                    How do we protect your information?
                  </h2>
                  <ul className="list-disc list-inside ml-6">
                    <li>
                      We take reasonable measures to protect your personal
                      information from unauthorized access, use, disclosure,
                      alteration, or destruction.
                    </li>
                    <li>
                      We use a variety of security measures, including
                      encryption, firewalls, and password protection.
                    </li>
                  </ul>
                </div>

                <div className="mb-4">
                  <h2 className="text-xl font-semibold">
                    How long do we retain your information?
                  </h2>
                  <ul className="list-disc list-inside ml-6">
                    <li>
                      We retain your personal information for as long as
                      necessary to provide you with the services you have booked
                      and to comply with our legal obligations.
                    </li>
                    <li>
                      We will then delete your personal information from our
                      records, unless you have consented to us retaining it for
                      a longer period of time.
                    </li>
                  </ul>
                </div>

                <div className="mb-4">
                  <h2 className="text-xl font-semibold">Your choices</h2>
                  <ul className="list-disc list-inside ml-6">
                    <li>
                      You can opt out of receiving marketing and promotional
                      materials from us by clicking the unsubscribe link in any
                      of our marketing emails.
                    </li>
                    <li>
                      You can request access to, correction of, or deletion of
                      your personal information by contacting us at{" "}
                      <a href="mailto:info@therusticpaths.com">info@therusticpaths.com</a>
                    </li>
                  </ul>
                </div>

                <div className="mb-4">
                  <h2 className="text-xl font-semibold">
                    Changes to this Privacy Policy
                  </h2>
                  <p>
                    We may update this privacy policy from time to time. If we
                    make any significant changes, we will post a notice on our
                    website and/or send you an email notification.
                  </p>
                </div>

                <div className="mb-4">
                  <h2 className="text-xl font-semibold">Contact us</h2>
                  <p>
                    If you have any questions about this Privacy Policy, please
                    contact us at{" "}
                    <a href="mailto:info@therusticpaths.com">info@therusticpaths.com</a>
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      {/*--------------------------- Our Achievements Section Start--------------------------*/}
      <section>
              <Container>
                <Row>
                  <Col lg="12">
                    {/* <div style={{ backgroundColor: "#ffffff" }}>
                      <h2 align="center" className="services__subtitle">
                        Few of our achievements
                      </h2>
                    </div> */}
                    <Subtitle subtitle={"Few of our achievements"}/>
                  </Col>
                  <Col lg="12">
                    <AchievementsSection />
                  </Col>
                </Row>
              </Container>
            </section>

            {/*--------------------------- Our Achievements Section End--------------------------*/}
      <Newsletter />
    </>
  );
};

export default PrivacyPolicy;
